import LogoFabula from "../assets/images/Fabula/logo-fabula.png";
import LogoMariaFilo from "../assets/images/mariaFilo/logo-mariafilo.png";
import LogoOFF from "../assets/images/offPremium/logo-off.png"; 
import LogoAnimale from "../assets/images/Animale/logo-animale.png"; 
import LogoFarm from "../assets/images/Farm/logo-farm.png"; 

export const ImageRelativeBrand = (env: string) => {
  switch (env) {
    case "lojaanimale":
      return {
        Image: LogoAnimale,
      };
    case "lojafabula":
      return {
        Image: LogoFabula,
      };
    case "lojafarm":
      return {
        Image: LogoFarm,
      };
    case "lojaoffpremium":
      return {
        Image: LogoOFF,
      };
    case "mariafilo":
      return {
        Image: LogoMariaFilo,
      };
    default:
      return {};
  }
};
